import DayPicker from "react-day-picker";

const CalendarDatePicker = (props) => {
  return <DayPicker {...props} />;
};

export default CalendarDatePicker;
